<template>
    <div class="l content_right">
        <div class="sea_bar cl">
            <div class="r">
                <div class="l filter_item inpt cl">
                    <el-input class="l" placeholder="用户名" icon="search" :on-icon-click="loadList" v-model="accountname" @keyup.enter.native="loadList"></el-input>
                    <el-select class="l" v-model="status" placeholder="状态" clearable @change="loadList">
                        <el-option
                                v-for="item in statusList"
                                :key="item.dictionaryid"
                                :label="item.dicvalue"
                                :value="item.dictionaryid">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="tools_bar">
            <el-button :disabled="selection.length !== 1" @click="handleUpdatePsw">修改密码</el-button>
            <el-button :disabled="selection.length !== 1" @click="handleConnectAccount">查看关联租户</el-button>
            <el-button :disabled="selection.length !== 1" @click="handleDelAccount">删除</el-button>
        </div>
        <div class="table_container account_list">
            <el-table :data="list" :height="tableHeight" @selection-change="listSelect" border>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="username1" label="用户名1(手机号)"></el-table-column>
                <el-table-column prop="username2" label="用户名2"></el-table-column>
                <el-table-column prop="username3" label="用户名3"></el-table-column>
                <el-table-column prop="statusTxt" label="状态"></el-table-column>
                <el-table-column prop="createtime" label="创建时间"></el-table-column>
            </el-table>
            <div class="paging">
                <el-pagination @current-change="handleCurrentPage" :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next" :total="totalSize"></el-pagination>
            </div>
        </div>
        <el-dialog
                title="修改密码"
                :visible.sync="updateDialog">
            <div class="info_content cl">
                <div class="info_line cl mb10">
                    <label class="l">新密码<span class="red">*</span>：</label>
                    <div class="l inpt"><el-input v-model="newpassword" :maxlength="8" placeholder="6-8个数字" @change="newpasswordChange"></el-input></div>
                </div>
            </div>
            <p style="margin-left: 17px;color: #aaa;margin-top: 10px;">说明：密码修改成功，系统会短信下发新密码给用户</p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateDialog = false">取 消</el-button>
                <el-button type="primary" @click="updatePsw">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
                title="帐号已关联租户"
                :visible.sync="connectDialog">
            <el-table
                    :data="connectList"
                    border
                    style="width: 100%">
                <el-table-column prop="tenantname" label="企业名称"></el-table-column>
                <el-table-column prop="tenantcode" label="企业号"></el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog
                title="删除账号"
                :visible.sync="deleteDialog" v-if="selection.length === 1">
                <div>
                    <p style="color:red">此功能只删除账号在平台的信息，账号在租户库内的数据请自行处理。</p>
                    <br />
                    <p>是否确认删除账号[{{selection[0].username1}}]？该账号关联以下租户:</p>
                    <br />
                    <el-table
                            :data="connectList"
                            border
                            @selection-change="selectedDel" 
                            style="width: 100%">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="tenantname" label="企业名称"></el-table-column>
                        <el-table-column prop="tenantcode" label="企业号"></el-table-column>
                    </el-table>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="deleteDialog = false">取消</el-button>
                    <el-button type="primary" @click="deleteAccount">确定</el-button>
                </div>
        </el-dialog>
    </div>
</template>
<script>
    import {API_ROOT} from '../../config/index'
    export default{
        data() {
            return {
                list: [],
                accountname: '',
                status: '',
                statusList: [
                    {
                        dicvalue: '启用',
                        dictionaryid: 1
                    },
                    {
                        dicvalue: '停用',
                        dictionaryid: 2
                    },
                    {
                        dicvalue: '下线',
                        dictionaryid: 3
                    }
                ],
                selection: [],
                currentPage: 1,
                pageSize: 15,
                totalSize: 0,
                updateDialog: false,
                newpassword: '',
                connectDialog: false,
                connectList: [],
                tableHeight: '',
                deleteDialog: false,
                deleteSelect:[]
            }
        },
        created() {
            this.init()
        },
        methods: {
            init() {
                this.loadList()
                this.tableHeight = window.innerHeight - 200
            },
            loadList() {
                let _this = this
                _this.$http.post('/platserv/tenantAccount/list', {
                    page: _this.currentPage,
                    rows: _this.pageSize,
                    status: _this.status,
                    accountname: _this.accountname
                }).then(res => {
                    _this.list = _this.formatData(res.data.resp_data.data)
                    _this.totalSize = res.data.resp_data.resultCount
                }).catch(error => {
                    _this.errorMessage(error)
                })
            },
            // 限制新密码为数字
            newpasswordChange(val) {
                let _this = this
                _this.$nextTick(function () {
                    _this.newpassword = (val + '').replace(/[^\d]/g, '')
                })
            },
            handleUpdatePsw() {
                if (this.selection.length === 0) {
                    this.$message.warning('请选择用户！')
                    return
                } else if (this.selection.length > 1) {
                    this.$message.warning('只能选择单个用户！')
                    return
                }
                this.updateDialog = true
            },
            updatePsw() {
                let _this = this
                if (_this.newpassword === '') {
                    _this.$message.warning('请输入新密码')
                    return
                } else if (this.newpassword.length < 6 || this.newpassword.length > 20) {
                    _this.$message.warning('请输入6-8位数字的新密码')
                    return
                }
                _this.$http.post('/platserv/tenantAccount/resetPwd', {
                    password: _this.newpassword,
                    accountinfocode: _this.selection[0].accountinfocode
                }).then(res => {
                    if (res.data.resp_data === 'ok') {
                        _this.$message.success('修改密码成功！')
                        _this.updateDialog = false
                    }else {
                        _this.$message.success('修改密码失败！')
                    }
                }).catch(error => {
                    _this.errorMessage(error)
                })
            },
            handleDelAccount(){
                let _this = this
                if(_this.selection.length === 0) {
                    _this.$message.warning("请选择用户! ")
                    return
                }
                else if (_this.selection.length > 1){
                    _this.$message.warning("只能选择单个用户！")
                    return 
                }
                _this.loadConnectTenantAccount()
                _this.deleteDialog = true
            },
            selectedDel(data){
                this.deleteSelect = data
            },
            deleteAccount(){
                let _this = this
                if(_this.deleteSelect.length === 0){
                    _this.$message.warning("请选择删除的租户")
                }
                else{
                    var deletedTenants = []
                    _this.deleteSelect.forEach(function(item){
                        console.log(item)
                        deletedTenants.push(item.tenantcode)
                    })
                    _this.$http.post('/platserv/tenantAccount/delTenantAccount',{
                    accountinfocode:_this.selection[0].accountinfocode,
                    tenantCodes:deletedTenants
                }).then(res => {
                    if(res.data.resp_data === "ok"){
                        _this.$message.success("删除账号成功！")
                        _this.loadList()
                    }
                    else{
                        _this.$message.success("删除账号失败！")
                    }
                }).catch(error => {
                    _this.errorMessage(error)
                })
                _this.deleteDialog = false
                }
                _this.deleteSelect = []
            },
            listSelect(data) {
                this.selection = data
            },
            handleCurrentPage(data) {
                this.currentPage = data
                this.loadList()
            },
            handleConnectAccount() {
                if (this.selection.length === 0) {
                    this.$message.warning('请选择用户！')
                    return
                } else if (this.selection.length > 1) {
                    this.$message.warning('只能选择单个用户！')
                    return
                }
                this.loadConnectTenantAccount()
                this.connectDialog = true
            },
            // 获取关联租户
            loadConnectTenantAccount() {
                let _this = this
                _this.$http.post('/platserv/tenantAccount/getAccountTenants', {
                    accountinfocode: _this.selection[0].accountinfocode
                }).then(res => {
                    _this.connectList = res.data.resp_data
                }).catch(error => {
                    _this.errorMessage(error)
                })
            },
            // 显示错误消息
            errorMessage(error) {
                let msg = (error.body && error.body.error_code) || error.statusText || error
                this.$message.error(msg)
            },
            // 转换列表信息
            formatData(data) {
                let  arr = ['启用', '停用', '下线']
                return data.map(item => {
                    item.statusTxt = arr[item.status - 1]
                    return item
                })
            },
            // 获取字典信息
            getDictionaryByKey(key) {
                let _this = this
                _this.$http.post(`/platserv/dictionary/getDictionaryByKey`,{dickey: key}).then(res => {
                    if (key === 'applytype') {
                        _this.statusList = res.data.resp_data
                    }
                }).catch(error => {
                    _this.errorMessage(error)
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Index.vue?72ee8bee